<template>
    <form action="" v-on:submit.prevent="login" class="login">
        <div class="login-control">
            <div class="input-icon" :class="emailStates">
                <i class="icon ico-mail"></i>
            </div>
            <input type="email" class="login-input" placeholder="email@email.com" v-model="email">
            <span class="login-input-error" v-if=error.email >{{ error.email }}</span>
        </div>
        <input class="btn recover login" :class="{ 'btn  login active': ok.form }" :disabled="!ok.form" type="submit" value="Enviar instrucciones" @click.prevent="passwordRecovery()" />
    </form>
</template>

<script>
const fb = require('@/main');

export default {
    name : 'ForgetPasswordForm',
    data: function(){
        return {
            email: '',
            error: {email:null},
            ok: {email:false, form:false},
            re: /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
        }
    },
    computed: {
        emailStates: function() {
            return {
            'input-icon-error': this.error.email,
            'input-icon-ok': this.ok.email
            }
        }
        },
        methods: {
            passwordRecovery: function(){
                var $this = this;
                let headers = {
                    'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6',
                }
                axios.get(process.env.VUE_APP_CORE_HOST+"/api/reset_password/?email="+this.email, {
                    headers: headers
                })
                .then((res) => {
                    console.log("Se envío el mail");
                    $this.$emit('forget-password');
                    this.send.message = 'Revisa tu correo, hemos enviado las instrucciones para crear una nueva contraseña.';
                })
                .catch((err) => {
                    console.log("Algo no salió bien", err)
                    this.send.message = 'Algo no salió bien, intenta nuevamente.';
                })

            }
        },
        watch: {
            email: {
                handler: function(val) {
                    if (this.re.test(val)) {
                        this.error.email = null;
                        this.ok.email = true;
                        this.ok.form = true;
                    } else if (!this.re.test(val)) {
                        this.ok.email = false;
                        this.ok.form = false;
                        if (val.length > 0) {
                            this.error.email = 'Formato de mail inválido.';
                        }
                    }
                },
                immediate: true
            }
    }
}
</script>
